import React from 'react'
import MyComponent from '../Activity/MyComponent'
import Storeaa from '../Store/Storeaa'

export default function Store() {
  return (
    <div>
    {/* <div style={{display:"flex"}}>
      <Storeaa/>
      <Storeaa/>
    </div> */}
    <MyComponent/>
    </div>
  )
}
